import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-export-dialog', {
    attrs: {
      "query": _vm.exportQuery,
      "formValid": _vm.formValid,
      "useBackgroundRunnerExport": true,
      "tenantId": _vm.tenantId,
      "format": "csv",
      "resource": _vm.ressource
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close-export-dialog');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Core.ExportDialog.titleTextCsv')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "subtitleParagraph",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Core.ExportDialog.dtwinStatesHint')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "fields",
      fn: function () {
        return [_c('core-date-time-picker', {
          staticStyle: {
            "margin-bottom": "30px !important"
          },
          attrs: {
            "from": _vm.start / 1000,
            "to": _vm.end / 1000,
            "isRange": ""
          },
          on: {
            "date:picked": _vm.datePicked
          }
        }), _c(VAutocomplete, {
          attrs: {
            "loading": _vm.variablesIsUpdating,
            "items": _vm.variables,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "clearable": "",
            "multiple": "",
            "chips": "",
            "label": _vm.$i18n_t('Core.ExportDialog.dtwinStates'),
            "item-text": "key",
            "return-object": "",
            "data-cy": "export_variables"
          },
          on: {
            "change": _vm.variablesChanged
          },
          model: {
            value: _vm.exportVariables,
            callback: function ($$v) {
              _vm.exportVariables = $$v;
            },
            expression: "exportVariables"
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };